import { render } from "./ChangeSettings.vue?vue&type=template&id=0bd09d27"
import script from "./ChangeSettings.vue?vue&type=script&lang=js"
export * from "./ChangeSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__